<template lang="html">
  <ValidationProvider rules="required|min:1" v-slot="{errors}" slim>
    <b-form-input
      autocomplete="off"
      :state="errors.length == 0"
      :value="propValue"
      @input="input"
      :type="type"
      :readonly="readonly"
      :placeholder="placeholder"
      @keydown.space.prevent
      @paste="removeEventSpaces"
      @drop="removeEventSpaces"
      :formatter="noSpaceFomatter"
    ></b-form-input>
    <!-- <b-form-invalid-feedback :state="errors.length == 0">필수 입력 필요</b-form-invalid-feedback> -->
  </ValidationProvider>
</template>

<script>
import {noSpaceFomatter} from '@/util/GeneralUtil';
export default {
  name: 'FormRequiredInput',
  props: {
    value: {
      required: true,
      default: null,
    },
    type: String,
    readonly: Boolean,
    placeholder: {
      type: [Number, String],
    },
  },
  data() {
    return {
      propValInternal: '',
    };
  },
  computed: {
    propValue() {
      return this.value;
    },
  },
  methods: {
    noSpaceFomatter: noSpaceFomatter,
    input(value) {
      console.log(`input:${value}`);
      this.$emit('input', value.replace(/ +/g, ''));
    },
    removeEventSpaces(e) {
      e.preventDefault();
      const left = e.target.value.substring(0, e.target.selectionStart);
      const right = e.target.value.substring(e.target.selectionEnd, e.target.value.length);
      const pasted = (e.dataTransfer || e.clipboardData).getData('text').replace(/ /g, '');
      e.target.value = left + pasted + right;
      this.input(left + pasted + right);
    },
  },
};
</script>
